import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type RewriteInsufficientSourcesDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  translationKeyPrefix: 'riskAssessmentPage' | 'manualGenerationPage'
  blockReason?: string | null
  availableSourceNames?: string[]
}

export function RewriteInsufficientSourcesDialog({
  open,
  onOpenChange,
  translationKeyPrefix,
  blockReason,
  availableSourceNames,
}: RewriteInsufficientSourcesDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const hasNamedSourceCopy =
    blockReason === 'missing_named_source' &&
    availableSourceNames != null &&
    availableSourceNames.length > 0

  let description = t(
    `${translationKeyPrefix}.rewriteInsufficientSourcesDialog.description`
  )
  if (hasNamedSourceCopy) {
    description = t(
      `${translationKeyPrefix}.rewriteInsufficientSourcesDialog.descriptionNamedSource`,
      { availableSources: availableSourceNames.join(', ') }
    )
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`${translationKeyPrefix}.rewriteInsufficientSourcesDialog.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            {t(`${translationKeyPrefix}.rewriteInsufficientSourcesDialog.close`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
